import { handleActions } from 'redux-actions'

import { PointCloudPageSettingsResponse } from '@tabeeb/contracts/main-api/swagger-main-api'
import { getPointCloudSettings, setPointCloudSettings, updatePointCloudSettings } from '../actions'

const defaultState: PointCloudPageSettingsResponse = {
  PageId: 0,
  MeasurementsScaleFactor: 1,
  Position: {
    X: 0,
    Y: 0,
    Z: 0,
  },
}

export default handleActions<PointCloudPageSettingsResponse, any>(
  {
    [getPointCloudSettings.success.toString()](state, { response }) {
      return response.data
    },
    [updatePointCloudSettings.request.toString()](state, { payload }) {
      return payload.settings
    },
    [setPointCloudSettings.toString()](state, { payload }) {
      return payload
    },
  },
  defaultState
)
